import { Fragment } from "react";
import { Link } from "react-router-dom";
import { Col, Label, Row } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { Add, Cancel, UploadProjectFiles } from "../../../../Constants/Constants";
import CommonFileUpload from "../../../CommonComponents/CommonFileUpload";

const UploadProjectFile = () => {
  return (
    <Fragment>
      <Row>
        <Col>
          <div className="mb-3">
            <Label>{UploadProjectFiles}</Label>
            <CommonFileUpload />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="text-end">
            <Btn type="submit" color="success" className="me-3">
              {Add}
            </Btn>
            <Link className="btn btn-danger" to={`${process.env.PUBLIC_URL}/applications/project/project-list`}>
              {Cancel}
            </Link>
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

export default UploadProjectFile;
